import { render, staticRenderFns } from "./viewCampaign.vue?vue&type=template&id=fbd5cdd0"
import script from "./viewCampaign.vue?vue&type=script&lang=js"
export * from "./viewCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports